<script lang="ts">
  import Button from '$components/elements/Button.svelte';
  import Form from '$components/elements/Form.svelte';
  import Icon from '$components/elements/Icon.svelte';
  import Input from '$components/elements/Input.svelte';
  import Modal from '$components/elements/Modal.svelte';
  import Flex from '$components/layout/Flex.svelte';
  import { submit } from '$lib/form';
  import { adminMode, editableTranslations } from '$lib/stores';
  import { types, validate } from '$src/routes/backend/translation/form';
  import { _, addMessages } from 'svelte-i18n';

  export let key: string;
  export let locale: string | undefined = undefined;

  let width: number | undefined = undefined;
  let height: number | undefined = undefined;

  let showModal = false;
  let onOpen = () => {
    showModal = true;
  };
  let onClose = () => {
    showModal = false;
  };
  let value = $_(key);
  const submitter = submit(onClose)(types, validate);
  // $: currentLocale = locale ?? $english ? 'en' : 'cs';
  $: currentLocale = 'cs'; // Default to 'cs' for now, the locale in the DB is always 'cs' for now
</script>

{#if $adminMode && $editableTranslations.has(key)}
  <Modal {showModal} width="1080px" {onClose}>
    <div class="editor">
      <Form submit={submitter('edit')} action="/backend/translation?/edit" let:status>
        <Flex width="100%" justifyContent="center" direction="column" gap="20px">
          <Flex width="100%" alignItems="center" justifyContent="space-between">
            <h4>Upravit text</h4>
            <Button
              border="1px solid #1D1D1B"
              color="transparent"
              textColor="#1D1D1B"
              slimness="slim"
              icon="cross"
              on:click={onClose}>Zavřít</Button
            >
          </Flex>
          <input name="key" value={key} hidden />
          <input name="lang" value={currentLocale} hidden />
          <Input name="text" type="textarea" label="Text" bind:value width="100%" required />
          <Button
            color="#C99E77"
            submit
            width="200px"
            {status}
            onFinished={() => {
              addMessages(currentLocale, {
                [key]: value
              });
              onClose();
            }}>Uložit</Button
          >
        </Flex>
      </Form>
    </div>
  </Modal>

  <span
    class="text"
    bind:offsetHeight={height}
    bind:offsetWidth={width}
    style={`
      --width: ${width}px;
      --height: ${height}px;
    `}
  >
    {@html $_(key, {
      locale
    })}
    <div class="text__icon" on:click={onOpen} on:keypress={onOpen}>
      <Icon icon="pencil" color="#62d250" />
    </div>
  </span>
{:else}
  {@html $_(key, {
    locale
  })}
{/if}

<style lang="scss">
  .editor {
    padding: 32px;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .text {
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    text-decoration: inherit;
    position: relative;
    display: inline-block;
    &__icon {
      cursor: pointer;
      z-index: 100;
      position: absolute;
      top: 0;
      right: -28px;
    }
    &::after {
      content: '';
      width: calc(var(--width) + 48px);
      height: calc(var(--height) + 16px);
      border-radius: 13px;
      border: 1.5px dashed $color-green;
      position: absolute;
      top: -8px;
      left: -8px;
    }
  }
</style>
